import { NgModule } from "@angular/core";
import { LootboxDashboardComponent } from "./dashboard/lootbox-dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";
import { CommonModule } from "@angular/common";
import { LootboxContentsComponent } from "./lootbox-contents/lootbox-contents.component";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from "src/app/app.module";
import { RewardCardComponent } from "./lootbox-card/reward-card.component";
import { SpinWinComponent } from "./spin-win/spin-win.component";
import { LottieModule } from "ngx-lottie";
import { LootboxInterceptor } from "src/app/interceptor/lootbox/lootbox.interceptor";

@NgModule({
  declarations: [
    LootboxDashboardComponent,
    LootboxContentsComponent,
    RewardCardComponent,
    SpinWinComponent,
  ],
  exports: [LootboxDashboardComponent],
  imports: [
    SharedModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LottieModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: LootboxInterceptor, multi: true
    }
  ]
})
export class LootboxModule { }
